export const datePikerMaskDefault = '99.99.9999';
export const datePikerMaskNotYear = '99.99';
